class FeaturedRotator extends HTMLElement {
  constructor() {
    super();
    this.slides = Array.from(this.querySelectorAll(':scope > .featured-rotator__slide'));
    this.interval = parseInt(this.dataset.interval, 10) || 4000;
    this.offset = parseInt(this.dataset.offset, 10) || 0;
    this.currentIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (this.currentIndex === -1) this.currentIndex = 0;

    this.next = this.next.bind(this);
    this.start = this.start.bind(this);

    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (this.slides.length > 1 && !prefersReducedMotion) {
      // Décalage de départ pour ne pas changer en même temps qu'un autre
      // carrousel de la même section.
      this.offsetTimer = setTimeout(this.start, this.offset);
    }
  }

  start() {
    this.timer = setInterval(this.next, this.interval);
  }

  next() {
    if (this.slides.length < 2) return;
    this.slides[this.currentIndex].classList.remove('is-active');
    this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    this.slides[this.currentIndex].classList.add('is-active');
  }

  disconnectedCallback() {
    clearTimeout(this.offsetTimer);
    clearInterval(this.timer);
  }
}

customElements.define('featured-rotator', FeaturedRotator);

// Les diapos non actives au chargement (produits 2 à N, photos équipe 2-3)
// portent leur image en data-src/data-srcset plutôt qu'en src, pour ne pas
// télécharger ~17 images inutiles dès le chargement de la page (une seule
// diapo par carrousel est visible à la fois). On les charge ici, une fois
// la page bien chargée et le thread principal disponible, largement avant
// que la rotation (toutes les 3,5s) n'en ait besoin.
(function () {
  function promoteDeferredImages() {
    document.querySelectorAll('.featured-rotator__deferred-img[data-src]').forEach(function (img) {
      img.src = img.getAttribute('data-src');
      var srcset = img.getAttribute('data-srcset');
      if (srcset) img.srcset = srcset;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    });
  }

  function schedule() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(promoteDeferredImages, { timeout: 2000 });
    } else {
      setTimeout(promoteDeferredImages, 1000);
    }
  }

  if (document.readyState === 'complete') {
    schedule();
  } else {
    window.addEventListener('load', schedule);
  }
})();

// Force une hauteur strictement identique entre les 3 carrés en la
// calculant en JS à partir de la largeur réelle, plutôt que de compter
// uniquement sur le CSS (aspect-ratio / astuce padding peuvent diverger
// légèrement d'un navigateur ou d'une colonne à l'autre).
(function () {
  function syncHeights() {
    var groups = document.querySelectorAll('.featured-products-intro');
    var isDesktop = window.matchMedia('(min-width: 750px)').matches;

    groups.forEach(function (group) {
      // Sur ordinateur : les 3 carrés (produits, équipe, histoire) restent
      // synchronisés comme avant, aucun changement. Sur mobile : seules les
      // 2 photos (côte à côte) sont synchronisées entre elles ; le bloc
      // texte "notre histoire" est désormais en pleine largeur en dessous et
      // suit sa propre hauteur de contenu (voir CSS), on ne le force plus.
      var rotators = isDesktop
        ? group.querySelectorAll(':scope > .featured-rotator')
        : group.querySelectorAll(':scope > .featured-rotator--products, :scope > .featured-rotator--team');
      if (rotators.length < 2) return;

      // Même ratio qu'avant sur ordinateur (4/3) ; sur mobile on utilise
      // désormais ce même ratio (au lieu de 3/4) car un format mobile trop
      // court écrasait le texte et les photos portrait des travailleurs.
      var ratio = 4 / 3;

      var width = rotators[0].getBoundingClientRect().width;
      if (!width) return;
      var height = Math.round(width * ratio) + 'px';

      rotators.forEach(function (el) {
        el.style.height = height;
      });

      if (!isDesktop) {
        var story = group.querySelector(':scope > .featured-rotator--story');
        if (story) story.style.height = '';
      }
    });
  }

  window.addEventListener('load', syncHeights);
  window.addEventListener('resize', syncHeights);
  document.addEventListener('DOMContentLoaded', syncHeights);
})();
